import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { submit } from "redux-form";
import { push } from "react-router-redux";
import parse from "url-parse";
import _ from "underscore";
//actions
import { actions } from "actions/resources";
import { searchProfiles } from "actions/search";
//antd
import { Col, Dropdown, Icon, Input, Menu, Table, Row } from "antd";
//utils
import ProgressiveImage from "react-progressive-image";
import defaultProfileImage from "images/default_profile.jpg";
import moment from "moment";

export class Students extends Component {
  state = {
    selectedCompany: null,
    selectedCompanyInfo: null,
    addEditFormVisible: false,
    infoFormVisible: false
  };

  componentWillMount() {
    this._fetchDependencies();
  }

  componentWillReceiveProps(nextProps) {
    const { fetchProfiles, studentsAlgolia } = this.props;
    if (
      nextProps &&
      nextProps.studentsAlgolia.length &&
      nextProps.studentsAlgolia !== studentsAlgolia
    ) {
      fetchProfiles({ id: _.pluck(nextProps.studentsAlgolia, "id") });
    }
  }

  _fetchDependencies = async () => {
    const { studentsAlgolia, searchProfiles } = this.props;

    if (!studentsAlgolia.length) {
      searchProfiles();
    }
  };

  _deleteStudent = async (recordId, email) => {
    const {
      profiles,
      fetchProfiles,
      studentsAlgolia,
      updateProfile,
      updateUser
    } = this.props;

    console.log(recordId, email);

    let confirmDelete = window.confirm(`${email} will be deleted, click in OK to proceed`);

    if (confirmDelete) {

      const profile = await updateProfile(recordId, {
        status: "deactivated"
      });

      await updateUser(profile.payload.user_id, {
        deactivated: true
      });
      window.location.reload();
      // return fetchProfiles({ id: _.pluck(studentsAlgolia.hits, "id") });
    }
  };


  _handleStudentStatus = async (recordId, recordStatus) => {
    const {
      fetchProfiles,
      studentsAlgolia,
      updateProfile,
      updateUser
    } = this.props;

    const profile = await updateProfile(recordId, {
      status: recordStatus
    });
    await updateUser(profile.payload.user_id, {
      deactivated: recordStatus === "deactivated" ? true : false
    });
    return fetchProfiles({ id: _.pluck(studentsAlgolia.hits, "id") });
  };

  _onSearchInput = e => {
    const { searchProfiles } = this.props;
    searchProfiles(e.target.value);
  };

  _recordStatus = (id, status) => {
    const { profiles } = this.props;
    let profile = _.findWhere(profiles, { id: id });

    if (profile) {
      return profile.status;
    }

    return status;
  };

  render() {
    const { redirect, studentsAlgolia } = this.props;
    const Search = Input.Search;
    const columns = [
      {
        align: "center",
        width: 60,
        render: (text, record, e) => {
          let profileImage = record.image || defaultProfileImage;
          if (parse(record.image).host === "www.wesolv.co") {
            profileImage = `https://legacy.wesolv.co${parse(record.image).pathname
              }`;
          }
          return (
            <div>
              <ProgressiveImage
                src={profileImage}
                placeholder={defaultProfileImage}
              >
                {src => (
                  <div
                    alt="profile"
                    src={src}
                    style={{
                      backgroundPosition: "center",
                      backgroundImage: `url(${src})`,
                      backgroundSize: "cover",
                      backgroundRepeat: "no-repeat",
                      height: "0px",
                      width: "40px",
                      borderRadius: "50%",
                      paddingTop: "40px"
                    }}
                  />
                )}
              </ProgressiveImage>
            </div>
          );
        }
      },
      {
        width: 150,
        title: "First Name",
        dataIndex: "first_name",
        key: "first_name",
        align: "center",
        sorter: (a, b) => {
          return a.first_name
            .toLowerCase()
            .localeCompare(b.first_name.toLowerCase());
        }
      },
      {
        width: 200,
        title: "Last Name",
        dataIndex: "last_name",
        key: "last_name",
        align: "center",
        sorter: (a, b) => {
          return a.last_name
            .toLowerCase()
            .localeCompare(b.last_name.toLowerCase());
        }
      },
      {
        width: 350,
        title: "Email",
        dataIndex: "email",
        key: "email",
        align: "center",
        sorter: (a, b) => {
          return a.email.toLowerCase().localeCompare(b.email.toLowerCase());
        }
      },
      {
        width: 100,
        title: "Create Date",
        key: "created_at",
        align: "center",
        render: a => {
          return moment(a.created_at).format("M/D/YYYY");
        }
      },
      {
        width: "150px",
        title: "Status",
        align: "center",
        dataIndex: "status",
        key: "status",
        sorter: (a, b) => {
          return a.status.toLowerCase().localeCompare(b.status.toLowerCase());
        },
        render: (text, record, e) => {
          return (
            <div>
              <span>
                {this._recordStatus(record.id, record.status) === "active" ? (
                  <div className="active">ACTIVE</div>
                ) : (
                  <div className="deactive">DEACTIVATED</div>
                )}
              </span>
            </div>
          );
        }
      },
      {
        key: "action",
        render: (text, record, e) => {
          const menu = (
            <Menu onClick={() => console.log("click")}>
              {this._recordStatus(record.id, record.status) === "active" ? (
                <Menu.Item key="1">
                  <div
                    className="active red"
                    onClick={() =>
                      this._deleteStudent(record.id, record.email)
                    }
                  >
                    DELETE
                  </div>
                </Menu.Item>
              ) : (
                <Menu.Item key="1">
                  <div
                    className="active"
                    onClick={() =>
                      this._handleStudentStatus(record.id, "active")
                    }
                  >
                    ACTIVATE
                  </div>
                </Menu.Item>
              )}

              <Menu.Item key="2">
                <a onClick={() => redirect(`/students/${record.id}`)}>
                  View Admin Page
                </a>
              </Menu.Item>
              <Menu.Item key="3">
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href={`${process.env.REACT_APP_WEB_URL}/profiles/${record.id
                    }`}
                >
                  View Portal Page
                </a>
              </Menu.Item>
            </Menu>
          );
          return (
            <span>
              <Dropdown placement="bottomCenter" overlay={menu}>
                <a>
                  <Icon type="setting" />
                </a>
              </Dropdown>
            </span>
          );
        }
      }
    ];

    return (
      <div className="detail-spacer">
        <Row>
          <Col type="flex" justify="center" align="middle">
            <h1 id="header">WeSolvers</h1>
          </Col>
        </Row>
        <Row>
          <Col type="flex" justify="center" align="middle">
            <Search
              placeholder="Search WeSolvers"
              onChange={this._onSearchInput}
            />
          </Col>
        </Row>
        <br />
        <Row justify="center" align="middle">
          <Table
            columns={columns}
            dataSource={studentsAlgolia.hits}
            rowKey="name"
            size="small"
            scroll={{ x: 600 }}
          />
        </Row>
      </div>
    );
  }
}

export default connect(
  state => ({
    students: state.resources.collection.profile || [],
    profile: state.resources.detail.profile,
    profiles: state.resources.collection.profile,
    studentsAlgolia: state.search.studentsAlgolia
  }),
  dispatch => ({
    fetchProfiles: bindActionCreators(actions.fetchProfiles, dispatch),
    fetchProfile: bindActionCreators(actions.fetchProfile, dispatch),
    submitForm: bindActionCreators(submit, dispatch),
    redirect: bindActionCreators(push, dispatch),
    updateProfile: bindActionCreators(actions.patchProfile, dispatch),
    updateUser: bindActionCreators(actions.patchUser, dispatch),
    searchProfiles: bindActionCreators(searchProfiles, dispatch)
  })
)(Students);



// WEBPACK FOOTER //
// ./src/components/dashboard/student/index.js